import { callBackendCommand, firebaseFunctionCommands } from '@/backend';
import { logger } from '@/utils/logger';

export interface ProjectInvitePreviewResult {
    status: 'valid' | 'invalid' | 'expired' | 'revoked' | 'accepted';
    orgId: string;
    projectId: string;
    invitationId: string;
    projectTitle?: string;
    invitedEmail?: string;
    inviteeName?: string;
    inviterName?: string;
    productionTitle?: string;
    accessRoleLabel?: string;
}

export interface JoinProjectResult {
    success: boolean;
    status: 'active' | 'invalid' | 'expired' | 'revoked' | 'reused' | 'email-mismatch';
    roleId?: string;
    personnelId?: string;
    authUid?: string;
    canonicalUserId?: string;
    identityRefreshRequired?: boolean;
    invitedEmail?: string;
    signedInEmail?: string;
    invitationId: string;
    projectId: string;
    orgId?: string;
}

export async function getProjectInvitePreview(input: {
    orgId: string;
    projectId: string;
    invitationId: string;
    token: string;
}): Promise<ProjectInvitePreviewResult> {
    return callBackendCommand(firebaseFunctionCommands.getProjectInvitePreview, input);
}

export async function requestInviteEmailUpdate(input: {
    orgId: string;
    projectId: string;
    invitationId: string;
    token: string;
    requestedEmail: string;
    note?: string;
}): Promise<{ success?: boolean }> {
    return callBackendCommand(firebaseFunctionCommands.requestInviteEmailUpdate, input);
}

/**
 * Accept a personnel-backed project invitation.
 */
export async function joinProject(
    orgId: string,
    projectId: string,
    invitationId: string,
    token: string,
    _userId: string,
    _userEmail: string
): Promise<JoinProjectResult> {
    try {
        return await callBackendCommand(firebaseFunctionCommands.acceptProjectInvite, { orgId, projectId, invitationId, token });
    } catch (error: unknown) {
        logger.error("Error joining project:", error);
        throw error;
    }
}














